<template>
  <div>
    <div class="structured-top">
      <h1 v-mark-word>{{ $t('myConsents.title') }}</h1>
      <span class="lead">{{ $t('myConsents.hint') }}</span>
    </div>
    <div>
      <BTabs>
        <BTab v-for="consents in [activeConsents, archivedConsents]" :title="consents.title" :key="consents.title">
          <div v-if="!consents.data.length">
            <table class="table structure-table">
              <thead>
              <tr class="consent-table-row">
                <td class="d-none d-xl-table-cell col-12">
                  <span v-if="consents === activeConsents">{{ $t('myConsents.emptyListActive')}}</span>
                  <span v-else>{{ $t('myConsents.emptyListArchived')}}</span>
                </td>
              </tr>
              </thead>
            </table>
          </div>
          <div v-else>
            <table class="table structure-table">
              <thead>
                <tr class="consent-table-row">
                  <th class="d-none d-xl-table-cell col-2">{{ $t('myConsents.table.columnStatus') }}</th>
                  <th class="d-none d-xl-table-cell col-2">{{ $t('myConsents.table.columnDate') }}</th>
                  <th class="d-none d-xl-table-cell col-2">{{ $t('myConsents.table.columnProduct') }}</th>
                  <th class="d-none d-xl-table-cell col-2">{{ $t('myConsents.table.columnRequester') }}</th>
                  <th class="d-none d-xl-table-cell col-4" />
                </tr>
              </thead>
              <tbody>
                <template v-for="consent in consents.data" :key="consent.id">
                  <tr class="consent-table-row">
                    <td class="consent-row-label" :class=labelStyle(consent.status)>{{ statusDescription(consent.status) }}</td>
                    <td class="">{{ consent.createdAt }}</td>
                    <td class="fw-bold">{{ productDescription(consent.type) }}</td>
                    <td>
                      <div class="gray-600 fw-bold">{{ consent.requesterCode }}</div>
                      <div>{{ consent.requesterName }}</div>
                    </td>
                    <td class="text-end">
                      <div v-for="log in consent.log" class="mb-1">
                        <span class="gray-600 fw-bold">{{ log.value }}</span>
                        <span v-if="log.time.length">: {{ log.time }}</span>
                      </div>
                      <div class="btn-col" v-if="consents.allowActions">
                        <a v-if="consent.actions.canDeny" class="btn btn-light m-1" @click="actionDeny(consent.id)">{{ $t('myConsents.button.deny') }}</a>
                        <a v-if="consent.actions.canAccept" class="btn btn-success m-1" @click="actionAccept(consent.id)">{{ $t('myConsents.button.accept') }}</a>
                        <a v-if="consent.actions.canRescind" class="btn btn-light m-1" @click="actionRescind(consent.id)">{{ $t('myConsents.button.rescind') }}</a>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </BTab>
      </BTabs>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import { BTab, BTabs } from 'bootstrap-vue-next';

export default {
  components: { BTab, BTabs },
  data: () => ({
    activeConsents: {
      title: '',
      data: [],
      allowActions: true,
    },
    archivedConsents: {
      title: '',
      data: [],
      allowActions: false,
    }
  }),
  computed: {
    ...mapState('session', ['profile']),
  },
  watch: {
    '$i18n.locale': function () {
      this.loadTabNames();
      this.loadConsents();
    },
  },
  methods: {
    ...mapActions('consents', ['getMyConsents', 'denyConsent', 'acceptConsent', 'rescindConsent']),
    ...mapMutations('session', ['redirectAfterLogin']),
    redirectIfNotLoggedIn() {
      if (!this.profile.personId) {
        this.redirectAfterLogin(this.$route.fullPath);
        this.$router.push({ name: `login-${this.$i18n.locale}`, params: { lang: this.$i18n.locale } });
      }
    },
    loadConsents() {
      this.getMyConsents()
        .then((response) => {
          this.activeConsents.data = response.activeData;
          this.archivedConsents.data = response.archivedData;
        });
    },
    loadTabNames() {
      this.activeConsents.title = this.$t('myConsents.activeTab');
      this.archivedConsents.title = this.$t('myConsents.historyTab');
    },
    statusDescription(status) {
      if (status === 'CREATED') {
        return this.$t('myConsents.status.created');
      } else if (status === 'APPROVED') {
        return this.$t('myConsents.status.approved');
      } else if (status === 'DENIED') {
        return this.$t('myConsents.status.denied');
      } else if (status === 'EXPIRED') {
        return this.$t('myConsents.status.expired');
      } else if (status === 'RESCINDED') {
        return this.$t('myConsents.status.denied');
      } else if (status === 'USED') {
        return this.$t('myConsents.status.approved');
      } else {
        return this.$t('myConsents.status.unknown');
      }
    },
    labelStyle(status) {
      return 'label-consent-' + status.toLowerCase();
    },
    productDescription(product) {
      if (product === 'FACTS AND FIGURES') {
        return this.$t('myConsents.product.factsAndFigures');
      } else if (product === 'PAYMENT DEFAULTS') {
        return this.$t('myConsents.product.paymentDefaults');
      } else if (product === 'RELATED COMPANIES') {
        return this.$t('myConsents.product.relatedCompanies');
      } else {
        return this.$t('myConsents.product.unknown');
      }
    },
    actionDeny(consentId) {
      this.denyConsent(consentId).then((response) => {
        if (response.status === 'success') {
          this.loadConsents();
        } else {
          alert('midagi läks valesti'); // TODO ??
        }
      });
    },
    actionAccept(consentId) {
      this.acceptConsent(consentId).then((response) => {
        if (response.status === 'success') {
          this.loadConsents();
        } else {
          alert('midagi läks valesti'); // TODO ??
        }
      });
    },
    actionRescind(consentId) {
      this.rescindConsent(consentId).then((response) => {
        if (response.status === 'success') {
          this.loadConsents();
        } else {
          alert('midagi läks valesti'); // TODO ??
        }
      });
    }
  },
  created() {
    this.redirectIfNotLoggedIn();
    this.loadTabNames();
    this.loadConsents();
  },
  metaInfo() {
    return {
      title: this.$t('myConsents.meta.title'),
      meta: [],
    };
  },
};
</script>
